import { firebase } from "../firebase";

export interface SeriesPoint {
  name: string;
  data: number[];
}

export interface ChartPayload {
  categories: string[];
  series: SeriesPoint[];
  projectedCount?: number;
}

export interface SubscriptionChartsRequest {
  start: string; // ISO timestamp
  end: string; // ISO timestamp (exclusive)
  interval: "daily" | "monthly" | "yearly";
  groupBy:
    | "none"
    | "platform"
    | "originationPlatform"
    | "product"
    | "businessName";
}

export interface SubscriptionChartsResponse {
  trialsStarted: ChartPayload;
  activeSubscriptions: ChartPayload;
  revenue: ChartPayload;
  mrr: ChartPayload;
  churn: ChartPayload;
}

export const fetchSubscriptionCharts = async (
  body: SubscriptionChartsRequest,
): Promise<SubscriptionChartsResponse> => {
  const currentUser = firebase.auth().currentUser;
  const token = await currentUser?.getIdToken(true);

  const response = await fetch("cs/subscriptionCharts", {
    body: JSON.stringify(body),
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
      Accepts: "application/json",
    },
  });

  const dt = await response.json();
  if (!response.ok || (response.status > 200 && response.status < 600)) {
    throw new Error(dt.error || response.statusText);
  }
  return dt;
};
